import React, { useState, useEffect } from "react";
import AdminSidebar from "../shared";
import { getNodeApiBase } from "../../../utils/apiBase";
import "./Comite.css";

const AjouterUneComite = () => {
  const [selectedItem, setSelectedItem] = useState("Comite");
  const [titreComite, setTitreComite] = useState("");
  const [competition, setCompetition] = useState("");
  const [evaluatorInput, setEvaluatorInput] = useState("");
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [selectedEvaluators, setSelectedEvaluators] = useState([]);
  const [competitions, setCompetitions] = useState([]);
  const [evaluteurs, setEvaluteurs] = useState([]);
  const [loadingCompetitions, setLoadingCompetitions] = useState(false);
  const [compFetchInfo, setCompFetchInfo] = useState("");

  useEffect(() => {
    let abort = false;
    const enumerateCompetitions = async () => {
      setLoadingCompetitions(true);
      const found = [];
      const seen = new Set();
      let id = 1;
      let emptyStreak = 0;
      const MAX_ID = 2000;          // broader search space
      const EMPTY_LIMIT_AFTER_FOUND = 30; // stop after 30 consecutive misses once we have data
      const GLOBAL_EMPTY_LIMIT = 150;     // or after 150 misses overall
      const apiBase = getNodeApiBase();
      while (!abort && id <= MAX_ID) {
        try {
          const res = await fetch(`${apiBase}/api/evaluateur/competitions/${id}`);
          if (!res.ok) {
            emptyStreak++;
          } else {
            const json = await res.json();
            if (json.status === 'success' && json.competition && json.competition.idcompetition != null) {
              const cid = json.competition.idcompetition;
              if (!seen.has(cid)) {
                seen.add(cid);
                found.push(json.competition);
              }
              emptyStreak = 0; // reset on hit
            } else {
              emptyStreak++;
            }
          }
        } catch { emptyStreak++; }
        if ((found.length > 0 && emptyStreak >= EMPTY_LIMIT_AFTER_FOUND) || emptyStreak >= GLOBAL_EMPTY_LIMIT) break;
        if (id % 100 === 0 && !abort) setCompFetchInfo(`Scan ID ${id} / hits: ${found.length}`);
        id++;
      }
      if (!abort) {
        found.sort((a,b)=> (a.idcompetition||0)-(b.idcompetition||0));
        setCompetitions(found);
        setCompFetchInfo( found.length ? `Trouvées: ${found.length}` : 'Aucune compétition détectée');
      }
      if (!abort) setLoadingCompetitions(false);
    };
    enumerateCompetitions();

    const apiBase = getNodeApiBase();
    fetch(`${apiBase}/api/evaluteurs`)
      .then(r=>r.json())
      .then(d=>{ if(!abort && d.evaluteurs) setEvaluteurs(d.evaluteurs); });

    return () => { abort = true; };
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  // Filter evaluteurs by nom or prenom
  const filteredEvaluators = evaluteurs.filter(
    (e) =>
      ((e.nom + " " + e.prenom)
        .toLowerCase()
        .includes(evaluatorInput.toLowerCase()) ||
        (e.prenom + " " + e.nom)
          .toLowerCase()
          .includes(evaluatorInput.toLowerCase())) &&
      !selectedEvaluators.some((sel) => sel.idevaluteur === e.idevaluteur)
  );

  const handleAddEvaluator = (evaluteur) => {
    setSelectedEvaluators([...selectedEvaluators, evaluteur]);
    setEvaluatorInput("");
  };

  const handleRemoveEvaluator = (idevaluteur) => {
    setSelectedEvaluators(
      selectedEvaluators.filter((e) => e.idevaluteur !== idevaluteur)
    );
  };

  const handleSaveComite = async (e) => {
    e.preventDefault();
    if (!competition || !titreComite) {
      alert("Veuillez remplir tous les champs obligatoires.");
      return;
    }
    try {
      // 1. Create comité
      const apiBase = getNodeApiBase();
      const response = await fetch(`${apiBase}/api/comite`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idcompetition: competition,
          titre_comite: titreComite,
        }),
      });
      const data = await response.json();
      if (data.success) {
        // 2. Link evaluators if any
        if (selectedEvaluators.length > 0) {
          const resEval = await fetch(
            `${apiBase}/api/comite/evaluateurs`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id_comite: data.id_comite,
                idevaluteurs: selectedEvaluators.map((e) => e.idevaluteur),
              }),
            }
          );
          const evalData = await resEval.json();
          if (!evalData.success) {
            alert(
              "Comité créé, mais erreur lors de l'ajout des évaluateurs : " +
                (evalData.message || "")
            );
            return;
          }
        }
        alert("Comité enregistré avec succès !");
        setTitreComite("");
        setCompetition("");
        setSelectedEvaluators([]);
      } else {
        alert(
          "Erreur lors de l'enregistrement du comité : " +
            (data.message || "")
        );
      }
    } catch (err) {
      alert("Erreur lors de l'enregistrement du comité.");
    }
  };

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "0.3rem",
    display: "block",
  };

  return (
    <div>
      <AdminSidebar />

      <div className="main-content" style={{ marginLeft: '250px', width: 'calc(100vw - 250px)', padding: '2rem', display: 'flex', justifyContent: 'center', boxSizing: 'border-box' }}>
        <div className="card" style={{ backgroundColor: '#fff', borderRadius: '10px', padding: '2rem', maxWidth: '1100px', width: '100%', margin: '0 auto', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '1.5rem' }}>Création de Comité</h2>
          <form onSubmit={handleSaveComite}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={labelStyle}>Compétition :</label>
              <select className="form-control" value={competition} onChange={(e) => setCompetition(e.target.value)} disabled={loadingCompetitions}>
                <option value="">{loadingCompetitions ? 'Chargement...' : 'Select Competition'}</option>
                {competitions.map((comp) => (
                  <option key={comp.idcompetition} value={comp.idcompetition}>
                    {comp.titre || comp.libelle || `Compétition #${comp.idcompetition}`}
                  </option>
                ))}
              </select>
              {compFetchInfo && <small style={{ color:'#555', display:'block', marginTop:4 }}>{compFetchInfo}</small>}
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={labelStyle}>Titre de Comité :</label>
              <input type="text" className="form-control" value={titreComite} onChange={(e) => setTitreComite(e.target.value)} placeholder="Entrer le titre" />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={labelStyle}>Liste Evaluateur :</label>
              <input type="text" className="form-control" placeholder="Rechercher..." value={evaluatorInput} onChange={(e) => setEvaluatorInput(e.target.value)} />
              {evaluatorInput && (
                <ul className="list-group mt-2">
                  {filteredEvaluators.map((e) => (
                    <li key={e.idevaluteur} className="list-group-item" style={{ cursor:'pointer' }} onClick={() => handleAddEvaluator(e)}>
                      {e.nom} {e.prenom}
                    </li>
                  ))}
                  {filteredEvaluators.length === 0 && <li className="list-group-item">Aucun résultat</li>}
                </ul>
              )}
              <div style={{ marginTop: '0.5rem', display: 'flex', flexWrap: 'wrap' }}>
                {selectedEvaluators.map((e) => (
                  <span key={e.idevaluteur} style={{ display:'inline-block', padding:'0.3rem 0.6rem', backgroundColor:'#e0e0e0', borderRadius:'15px', margin:'0.25rem', fontSize:'0.9rem' }}>
                    {e.nom} {e.prenom}
                    <span style={{ cursor:'pointer', marginLeft:6 }} onClick={() => handleRemoveEvaluator(e.idevaluteur)}>x</span>
                  </span>
                ))}
              </div>
            </div>
            <button type="submit" className="btn w-100" style={{ backgroundColor:'#007bff', color:'white' }}>Enregistrer</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AjouterUneComite;

